//
//
//
//
//
//
//
//
//
//
//

export default {

  data () {
  return {
    data:{},
  }
  },
  components:{
    'v-footer': "footer"
  },
  mounted(){
    this.$axios.post( `/v9/index/getPcGetInfo`).then(res => {
      if(res.data.code == 200){
        this.data=res.data.data
      }
    })
  },
  methods: {
  },
  created () {
  }
}



// WEBPACK FOOTER //
// ./src/components/common/footer.vue